import cx from 'classnames';
import styles from 'partials/data-table/data-table.module.scss';

export const DataTableRow = ({ children, className }) => {
	const rowClass = cx(styles.row, className);
	return <li className={rowClass}>{children}</li>;
};
